import { render } from "./pcidevices-controller.vue?vue&type=template&id=52c71839&scoped=true"
import script from "./pcidevices-controller.vue?vue&type=script&lang=js"
export * from "./pcidevices-controller.vue?vue&type=script&lang=js"

import "./pcidevices-controller.vue?vue&type=style&index=0&id=52c71839&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c71839"]])

export default __exports__